var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMiniLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6515_6579)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36 18C36 21.816 35.7971 25.5207 35.424 29.0553C35.0509 32.5898 32.4196 35.064 29.0553 35.424C25.5273 35.8036 21.8225 36 18 36C14.1775 36 10.4793 35.7971 6.94473 35.424C3.41018 35.0509 0.936 32.4196 0.576 29.0553C0.196364 25.5273 0 21.8225 0 18C0 14.1775 0.202909 10.4793 0.576 6.94473C0.949091 3.41018 3.58036 0.936 6.94473 0.576C10.4727 0.196364 14.1775 0 18 0C21.8225 0 25.5207 0.202909 29.0553 0.576C32.5898 0.949091 35.064 3.58036 35.424 6.94473C35.8036 10.4727 36 14.1775 36 18Z",
    fill: "url(#paint0_radial_6515_6579)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.371 14.4922C28.153 14.4926 28.5802 15.3953 28.0868 16.003L18.537 27.7608C17.5682 28.9522 15.6723 27.9291 16.1357 26.4668L16.1298 26.461L19.7284 15.1358C19.8489 14.7509 20.2102 14.4922 20.6132 14.4922H27.371ZM17.4677 8.24027C18.4365 7.04888 20.3314 8.07199 19.8681 9.53421L19.8749 9.54007L16.2763 20.8653C16.1558 21.2502 15.7945 21.5088 15.3915 21.5088H8.63371C7.85155 21.5087 7.4245 20.6058 7.91789 19.9981L17.4677 8.24027Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_6515_6579",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18 43.2547) rotate(-90) scale(66.3949)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4C67E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E155A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6515_6579"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiniLogo);
export default __webpack_public_path__ + "static/media/mini-logo.7c978be754f9c408c1b5218e4d47de03.svg";
export { ForwardRef as ReactComponent };